import { Text } from 'components';
import React from 'react';
import { TableComponents } from 'screens/Admin/components';
import { ListItem } from './';

const List = ({ data, onClick, dataId, loading }) => {
  return (
    <TableComponents.List
      loading={loading || !data}
      Header={() => (
        <React.Fragment>
          <TableComponents.Th first>
            <Text>Sport</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Sides</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Location</Text>
          </TableComponents.Th>

          <TableComponents.Th>
            <Text>Date</Text>
          </TableComponents.Th>
        </React.Fragment>
      )}
      Items={() =>
        !loading && data
          ? data.map((item, i) => (
              <ListItem
                key={i}
                dataId={dataId}
                isSelected={dataId === item._id}
                onClick={onClick}
                item={item}
              />
            ))
          : null
      }
    />
  );
};

export default List;
